import { useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { EnvService, IStorageSession } from 'namirasoft-core';
import { NSNotFoundPage } from 'namirasoft-site-react';
import { NSARouterMaker, NSARouterMakerProps } from 'namirasoft-account-react';
import { NamirasoftCredentialServer } from 'namirasoft-credential';
import { CredentialRoutes } from "./CredentialRoutes";

// Pages
import Home from "./pages/HomePage";
import LoginPage from './pages/LoginPage';

// AWS
import AWSEditPage from "./pages/AWSEditPage";
import AWSViewPage from './pages/AWSViewPage';
import AWSListPage from './pages/AWSListPage';

// Azure
import AzureViewPage from './pages/AzureViewPage';
import AzureEditPage from './pages/AzureEditPage';
import AzureListPage from './pages/AzureListPage';

// GCP
import GCPViewPage from './pages/GCPViewPage';
import GCPEditPage from './pages/GCPEditPage';
import GCPListPage from './pages/GCPListPage';

export default function Router()
{
    let [state, setState] = useState<number>(Math.random());

    let location = useLocation();
    let navigate = useNavigate();

    let maker = new NSARouterMaker(new IStorageSession(), () => { setState(state + Math.random()); }, {
        onRenderOnLogin: (props: NSARouterMakerProps) =>
        {
            let REACT_APP_BASE_URL_CREDENTIAL = new EnvService("REACT_APP_BASE_URL_CREDENTIAL", true).getString();
            let server = {
                credential: new NamirasoftCredentialServer(REACT_APP_BASE_URL_CREDENTIAL, props.account.token_manager, props.notifier.onError),
            }
            return (
                <>
                    <Routes>
                        <Route path={CredentialRoutes.Home} element={<Home {...props} />} />

                        <Route path={CredentialRoutes.AWSList} element={<AWSListPage {...props} servers={server} />} />
                        <Route path={CredentialRoutes.AWSNew} element={<AWSEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={CredentialRoutes.AWSCopy(":id")} element={<AWSEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={CredentialRoutes.AWSEdit(":id")} element={<AWSEditPage {...props} servers={server} isEdit={true} />} />
                        <Route path={CredentialRoutes.AWSView(":id")} element={<AWSViewPage {...props} servers={server} />} />

                        <Route path={CredentialRoutes.AzureList} element={<AzureListPage {...props} servers={server} />} />
                        <Route path={CredentialRoutes.AzureNew} element={<AzureEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={CredentialRoutes.AzureCopy(":id")} element={<AzureEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={CredentialRoutes.AzureEdit(":id")} element={<AzureEditPage {...props} servers={server} isEdit={true} />} />
                        <Route path={CredentialRoutes.AzureView(":id")} element={<AzureViewPage {...props} servers={server} />} />

                        <Route path={CredentialRoutes.GCPList} element={<GCPListPage {...props} servers={server} />} />
                        <Route path={CredentialRoutes.GCPNew} element={<GCPEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={CredentialRoutes.GCPCopy(":id")} element={<GCPEditPage {...props} servers={server} isEdit={false} />} />
                        <Route path={CredentialRoutes.GCPEdit(":id")} element={<GCPEditPage {...props} servers={server} isEdit={true} />} />
                        <Route path={CredentialRoutes.GCPView(":id")} element={<GCPViewPage {...props} servers={server} />} />

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes>
                </>
            );
        },
        onRenderOnLogout: () =>
        {
            return (
                <Routes>
                    <Route path={CredentialRoutes.Home} element={<LoginPage />} />
                    <Route path="*" element={<LoginPage />} />
                </Routes>
            );
        }
    }, location, navigate);

    return maker.onRender();
}